import { createContext } from 'react';

export default createContext({
  locale: 'no',
  fullLocale: 'nb-NO',
  phrases: {},
});
